import homeIndex from './pages/homeIndex'
import forgetPasswordPage from './pages/forgetPassword'
import applyMaster from './pages/applyMaster'
const pageRouters = [
  homeIndex,
  forgetPasswordPage,
  applyMaster
]

export default pageRouters



// WEBPACK FOOTER //
// ./src/router/pageRouters.js